import React, { useState } from 'react';
import imgPlanEstandar from '../../assets/images/plans/plan-estandar.png';
import imgPlanPro from '../../assets/images/plans/plan-pro.png';
import Text from '../../components/text/Text';
import SvgIcon from '../../components/svgIcon/SvgIcon';
import './MyPlan.css';

interface FeatureRowProps {
	title: string;
	description: string;
	icon: IconName;
	subtitle?: string;
	featureColor?: string;
}

const FeatureRow: React.FC<FeatureRowProps> = ({ title, description, icon, subtitle, featureColor }) => {
	const [isExpanded, setIsExpanded] = useState(false);

	return (
		<div style={{ display: 'flex', flexDirection: 'column' }}>
			<div style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
				<SvgIcon iconName={icon} />
				<div style={{ display: 'flex', flexDirection: 'column' }}>
					{subtitle && <Text fontSize={10} color={featureColor || '#2699D6'} fontWeight={600} label={subtitle} fontFamily='Poppins' marginLeft={10} />}
					<Text fontSize={16} color={featureColor || '#2699D6'} fontWeight={600} label={title} fontFamily='Poppins' marginLeft={10} />
				</div>

				{/* Botón para expandir/cerrar */}
				<button
					onClick={() => setIsExpanded(!isExpanded)}
					style={{
						marginLeft: 10,
						cursor: 'pointer',
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						background: 'none',
						border: 'none'
					}}
				>
					<Text
						fontSize={12}
						color="#565656"
						fontWeight={600}
						label={isExpanded ? "Ver menos" : "Ver más"}
						fontFamily='Poppins'
					/>
					<span style={{ marginLeft: 5 }}>
						<SvgIcon iconName={isExpanded ? "PIconChevronUp" : "PIconChevronDown"} />
					</span>
				</button>
			</div>

			{/* Contenido expandible */}
			{isExpanded && (
				<div style={{ marginTop: 10 }}>
					<Text fontSize={16} color="#656565" fontWeight={400} label={description} fontFamily='Poppins' />
				</div>
			)}
			<div style={{ borderBottom: '1px solid #D9D9D9', marginTop: 10 }} />
		</div>
	);
};

export default function MyPlan() {

	const [plan, setPlan] = useState('PRO');

	return (
		<div>
			{/* header */}
			<div className="my-plan-container" style={{ backgroundImage: `url(${plan === 'PRO' ? imgPlanPro : imgPlanEstandar})` }}>
				<div className="my-plan-content">
					<Text fontSize={26} color="#fff" fontWeight={'bold'} label="Mi Plan" fontFamily='Poppins' />
					<Text fontSize={128} color="#fff" fontWeight={400} label={plan === 'PRO' ? 'PRO' : plan === 'ESTANDAR' ? 'ESTANDAR' : 'PLAN BASE'} fontFamily='Chewy' />
					<Text fontSize={20} color="#fff" fontWeight={400} label="Medio de pago vinculado a suscripción" fontFamily='Poppins' marginBottom={10} />
					<SvgIcon iconName={"OtherPaymentMethod"} />
				</div>
			</div>
			{/* local */}
			<div style={{ marginTop: 20, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
				<div style={{ display: 'flex', flexDirection: 'row' }}>
					<Text fontSize={24} color="#2699D6" fontWeight={400} label="Local: " fontFamily='Poppins' />
					<Text fontSize={24} color="#2699D6" fontWeight={700} label="Cafeteria Juanita" fontFamily='Poppins' />
				</div>
				<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
					<div style={{ display: 'flex', flexDirection: 'row' }}>
						<Text fontSize={16} color="#2699D6" fontWeight={400} label="Valor: " fontFamily='Poppins' />
						<Text fontSize={16} color="#2699D6" fontWeight={700} label="$XX.XXX/año" fontFamily='Poppins' />
					</div>
					<div style={{ display: 'flex', flexDirection: 'row' }}>
						<Text fontSize={16} color="#2699D6" fontWeight={400} label="Próximo cobro: " fontFamily='Poppins' />
						<Text fontSize={16} color="#2699D6" fontWeight={700} label=" agosto 02, 2024" fontFamily='Poppins' />
					</div>
				</div>
			</div>
			{/* funciones */}
			<div style={{ marginTop: 20 }}>
				<Text fontSize={18} color="#565656" fontWeight={400} label="Funciones disponibles:" fontFamily='Poppins' />
			</div>
			{/* features */}
			<FeatureRow icon='PIconCheck' title='Pago QR' description='Podrás cobrar a tus clientes con un sólo clic. Abre tu cámara, escanea el código y ya tienes tu pago.' />
			<FeatureRow icon='PIconCheck' title='Resumen de ventas' description='Revisa un resumen con tus ventas diarias, semanales o mensuales y mantente informado sobre los ingresos de tu negocio.' />
			<FeatureRow icon='PIconCheck' title='Anticipa tus pagos' description='Revisa tus proformas, facturas y montos por facturar. Y si quieres, solicita el pago anticipado de tus ingresos.' />
			<FeatureRow icon='PIconCheck' title='Sello ecofriendly' description='Súmate al cuidado del planeta. Con 7 preguntas y en menos de 1 minuto podrás unirte a los comercios que contribuyen con el cuidado del medioambiente.' />
			<FeatureRow icon={plan === 'BASE' ? 'PIconLocked' : 'PIconCheck'} title='Liquida productos próximos a vencer' description='Vende tu merma antes de que se pierda, ofrécela a tus clientes frecuentes a precios especiales.' />
			<FeatureRow icon={plan === 'BASE' ? 'PIconLocked' : 'PIconCheck'} title='Promociones' description='Atrae nuevos clientes a tu local con promociones especiales a productos específicos, al total de la compra o al delivery.' />
			<FeatureRow icon={plan === 'BASE' ? 'PIconLocked' : 'PIconCheck'} title='Marketplace amiPASS' description='Vende tus productos en la app amiPASS, carga tu inventario, define tu stock y súmate a las ventas digitales.' />
			<FeatureRow icon={plan === 'BASE' ? 'PIconLocked' : 'PIconCheck'} title='Delivery amiPASS' description='Impulsa tus ventas remotas con el delivery amiPASS. Carga tus productos y véndelos con despacho a domicilio.' />
			<FeatureRow icon={plan === 'PRO' ? 'PIconStar' : 'PIconLocked'} title='Tu ecommerce' subtitle='Exclusivo plan PRO' featureColor={plan === 'PRO' ? '#62B565' : '#656565'} description='Obtén tu propio sitio web y vende tus productos por internet con un e-commerce completamente integrado y automatizado con tu tienda en la app de amiPASS.' />
		</div>

	);
}
